/* =========================================================
   TIMESHOPEE · INSTALL APP (PWA)
   - Android/desktop Chrome: uses the native install prompt
   - iOS Safari / browsers without the prompt: shows step sheet
   Any element with [data-pwa-install] starts the install flow.
   ========================================================= */
(function () {
  if (window.__nvPwa) return;
  window.__nvPwa = true;

  var banner = document.getElementById('nv-install');
  var sheet = document.getElementById('nv-sheet');
  var footer = document.getElementById('nv-install-footer');
  if (!banner || !sheet) return;

  var KEY = 'nv_pwa_state';
  var HIDE_HOURS = 12;   // after the visitor closes the banner, do not show it again for this long
  var ua = navigator.userAgent || '';
  var isIOS = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isAndroid = /android/i.test(ua);
  var isMobile = isIOS || isAndroid || window.matchMedia('(max-width: 749px)').matches;
  var standalone = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
  var deferred = null;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { /* private mode */ } }
  function dismissed() {
    var s = read();
    if (s.installed) return true;
    return s.dismissedAt && (Date.now() - s.dismissedAt) < HIDE_HOURS * 3600000;
  }

  if (standalone) { document.documentElement.classList.add('nv-standalone'); return; }

  function showBanner() {
    if (dismissed() || !isMobile) return;
    banner.hidden = false;
    requestAnimationFrame(function () { banner.classList.add('is-on'); });
  }
  function hideBanner() {
    banner.classList.remove('is-on');
    setTimeout(function () { banner.hidden = true; }, 350);
  }
  function showFooterLink() {
    if (footer && isMobile && !read().installed) footer.hidden = false;
  }
  function openSheet() {
    var kind = isIOS ? 'ios' : (isAndroid ? 'android' : 'other');
    sheet.querySelectorAll('[data-steps]').forEach(function (ol) { ol.hidden = ol.getAttribute('data-steps') !== kind; });
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-on'); });
  }
  function closeSheet() {
    sheet.classList.remove('is-on');
    setTimeout(function () { sheet.hidden = true; }, 300);
  }

  function install() {
    if (deferred) {
      var p = deferred;
      deferred = null;
      p.prompt();
      (p.userChoice || Promise.resolve({})).then(function (c) {
        if (c.outcome === 'accepted') { var s = read(); s.installed = true; write(s); }
        hideBanner();
      });
      return;
    }
    hideBanner();
    openSheet();
  }

  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault();
    deferred = e;
    document.documentElement.classList.add('nv-can-install');
    setTimeout(showBanner, 2500);
    showFooterLink();
  });
  window.addEventListener('appinstalled', function () {
    var s = read(); s.installed = true; write(s);
    hideBanner();
    if (footer) footer.hidden = true;
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pwa-install],[data-pwa-dismiss],[data-pwa-sheet-close]');
    if (!t) return;
    if (t.hasAttribute('data-pwa-install')) { e.preventDefault(); install(); }
    else if (t.hasAttribute('data-pwa-dismiss')) { var s = read(); s.dismissedAt = Date.now(); write(s); hideBanner(); }
    else closeSheet();
  });

  // Browsers that never fire beforeinstallprompt (iOS Safari, some Android browsers)
  setTimeout(function () {
    if (deferred) return;
    showFooterLink();
    showBanner();
  }, 5000);

  window.nvPwa = { install: install };
})();
